import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { getProperty, setProperty } from 'dot-prop';
import { BehaviorSubject, distinct, skip, skipUntil, skipWhile, Subject } from 'rxjs';

@Component({
    selector: 'lgv-formly-multi-select-checkbox',
    templateUrl: './formly-multi-select-checkbox.component.html',
    styleUrls: ['./formly-multi-select-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyMultiSelectCheckboxComponent extends FieldType<FieldTypeConfig> implements OnInit {
    checkboxFormList: FormGroup;
    isFormDoneInitializing$ = new Subject();
    constructor(private fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {
        this.checkboxFormList = this.fb.group([]);
        for (let i =0; i < (this.props?.options as any[]).length; i ++) {
            const currentValues = getProperty(this.model, this.field.key as string) ?? [];
            const value = currentValues?.findIndex(cv => cv == this.props?.options[i].fieldName) >= 0;
            this.checkboxFormList.addControl(this.props?.options[i].fieldName,  this.fb.control(value));
            if(i == (this.props?.options as any[]).length-1) {
                this.checkboxFormList.valueChanges.pipe(distinct()).subscribe(form => {
                    let model = getProperty(this.model, this.field.key as string) ?? [];   
                    Object.keys(form).forEach((key) => {
                        if(form[key] && !model.includes(key)) {
                            model.push(key);
                        }
                    });
                    setProperty(this.model, this.field.key as string, model);
                });
            }
        };
    }

}
